import userApi from '@/api/now/userApi'
import store from '@/store'
import router from '@/router'

import LoanService from '@/service/loan/LoanService'

import { sleep } from '@/util'

const statuses = {
  NOT_DEFINED: {
    code: 'not_defined',
    down: '내 한도 확인하기',
  },
  NO_CFA_ACCOUNT: {
    code: 'no_cfa_account',
    down: '내 한도 확인하기',
    route: 'cardsales/form',
  },
  NOT_CFA_ACCOUNT: {
    code: 'not_cfa_account',
    down: '여신금융협회 계정 오류',
  },
  NO_CARDSALES: {
    code: 'no_cardsales',
  },
  NOT_CARDSALES: {
    code: 'not_cardsales',
  },
  NO_CREDIT: {
    code: 'no_credit',
    top: '신청 가능 비상금',
    down: '1분 정보 등록하고 비상금 신청하기 >',
    route: 'kyc/form',
  },
  NOT_CREDIT: {
    code: 'not_credit',
    top: '신청 가능 비상금',
    down: '1분 정보 등록하고 비상금 신청하기 >',
    route: 'kyc/form',
  },
  NO_CONTRACT: {
    code: 'no_contract',
  },
  SERVICE_APPLIED: {
    code: 'service_applied',
    top: '신청 가능 비상금',
    down: '서비스 이용 신청 완료!',
  },
  DOCUMENTS_SUBMITTED: {
    code: 'documents_submitted',
    top: '신청 가능 비상금',
    down: '서류 제출 및 약관 동의 중!',
  },
  PARTIALLY_STARTED: {
    code: 'partially_started',
    top: '신청 가능 비상금',
    down: '비상금 계약 완료!',
  },
  CANCELED: {
    code: 'canceled',
    top: '신청 가능 비상금',
    down: '계약 일시 중단',
  },
  COMPLETED: {
    code: 'completed',
    top: '신청 가능 비상금',
    down: '비상금 계약 완료!',
  },
  STARTED: {
    code: 'started',
    top: '신청 가능 비상금',
    down: '원클릭신청',
    route: 'documents/limittransaction',
  },
  NOSTART: {
    code: 'nostart',
    top: '신청 가능 비상금',
    down: '시스템 점검 중',
  },
  RECEIVED: {
    code: 'received',
    top: '투자 모집중',
    down: '계약서 작성하기',
    route: 'documents/limittransaction',
  },
  INVESTING: {
    code: 'investing',
    top: '투자 모집중',
    down: '현재 투자금을 모집중 입니다.',
    route: 'documents/limittransaction',
  },
  INVESTED: {
    code: 'invested',
    top: '입금 예정 금액',
    down: '계약서 작성하기',
    route: 'documents/limittransaction',
  },
  EXECUTING: {
    code: 'executing',
    top: '입금 예정 금액',
    down: '입금을 위한 절차가 완료되었습니다. ^^',
  },
  EXECUTED_SOON: {
    code: 'executed_soon',
    top: '상환 예정 비상금',
    down: '비상금 곧 입금 예정!',
  },
  EXECUTED_TODAY: {
    code: 'executed_today',
    top: '상환 중인 비상금',
    down: '비상금 입금 완료!',
  },
  EXECUTED_STILL: {
    code: 'executed_still',
    top: '상환 중인 비상금',
    down: '비상금 상환 중!',
  },
  REEXECUTABLE: {
    code: 'reexecutable',
    top: '추가 신청 가능 비상금',
    down: '원클릭신청',
    route: 'documents/limittransaction',
  },
  NONLOANABLE: {
    code: 'nonloanable',
    top: '상환중인 비상금',
    down: '비상금 신청 불가',
  },
  CLOSEDSTATUS: {
    code: 'closed_status',
    down: '휴/폐업사실이 확인되어 대출 진행이 불가합니다.'
  }
}

const statusesSet = {
  statusesCardsales: [
    statuses.NOT_DEFINED.code,
    statuses.NO_CFA_ACCOUNT.code,
    statuses.NOT_CFA_ACCOUNT.code,
    statuses.NO_CARDSALES.code,
    statuses.NOT_CARDSALES.code
  ],
  statusesCredit: [
    statuses.NO_CREDIT.code,
    statuses.NOT_CREDIT.code,
    statuses.NO_CONTRACT.code
  ],
  statuesExecutable: [
    statuses.STARTED.code,
    statuses.REEXECUTABLE.code
  ],
  statuesExecuted: [
    statuses.EXECUTING.code,
    statuses.EXECUTED_SOON.code,
    statuses.EXECUTED_TODAY.code,
    statuses.EXECUTED_STILL.code,
  ],
  statuesReexecutable: [
    statuses.REEXECUTABLE.code
  ],
  statuesInvesting: [
    statuses.RECEIVED.code,
    statuses.INVESTING.code,
    statuses.INVESTED.code,
    statuses.EXECUTING.code,
  ],
  statusesNotLoan: [
    statuses.NOT_DEFINED.code,
    statuses.NO_CFA_ACCOUNT.code,
    statuses.NOT_CFA_ACCOUNT.code,
    statuses.NO_CARDSALES.code,
    statuses.NOT_CARDSALES.code,
    statuses.NO_CREDIT.code,
    statuses.NOT_CREDIT.code,
    statuses.NO_CONTRACT.code,
    statuses.SERVICE_APPLIED.code,
    statuses.DOCUMENTS_SUBMITTED.code,
    statuses.PARTIALLY_STARTED.code,
    statuses.COMPLETED.code,
    statuses.CANCELED.code,
    statuses.STARTED.code
  ],
}

const INTEVAL_MULTIPLICATION = 1.2
const START_POLLING_TIME = new Date()
const MAX_POLLING_TIME = 5 * 60 * 1000

let statusService = {
  statuses,
  statusesSet,
  async routeToCardSalesForm() {
    // 여신계정 없을때 약관내용 보는 경우 페이지 이동 방지
    if (location.pathname.indexOf('/terms/') === -1) {
      // 여신 계정 없을 때에만 이동
      let status = store.getters['status/getStatus']
      if (statuses.NO_CFA_ACCOUNT.code === status.code) {
        await router.push({ name: 'cardsales/form' })
      }
    }
  },
  async setMerchantInfos() {
    let status = store.getters['status/getStatus']
    if (!status.code) {
      return
    }

    let user = store.getters['auth/getProfile']
    if (
      !user.store.business_license_number &&
      ![statuses.NO_CFA_ACCOUNT.code, statuses.NOT_CFA_ACCOUNT.code].includes(status.code)
    ) {
      await router.push({ name: 'cardsales/list' })
    }
  },
  async pollStatus() {
    let { data } = await userApi.getStatus()

    if (data) {
      let status = { ...data, ...statuses[data.status.toUpperCase()] }
      store.dispatch('status/setStatus', status)

      await this.setMerchantInfos()

      LoanService.pollOffer()
      return
    }

    let pollingInterval = 0.5 * 60 * 1000
    await sleep(pollingInterval)

    pollingInterval *= INTEVAL_MULTIPLICATION
    let durationTime = new Date() - START_POLLING_TIME
    if (durationTime < MAX_POLLING_TIME) {
      this.pollStatus()
    }
  },
  async syncStatus() {
    if (store.getters['auth/isSignin'] === false) {
      return
    }
    await this.pollStatus()
    await this.routeToCardSalesForm()
  }
}
export default statusService
